var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"intersect",rawName:"v-intersect",value:(_vm.onIntersect),expression:"onIntersect"}],tag:"component",attrs:{"data-last":_vm.isLast}},[_vm._t("default",null,{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }